/* eslint-disable no-param-reassign */
// @flow
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { toast } from 'react-toastify';
import Grid from '@mui/material/Unstable_Grid2';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { getGreeting } from 'utils/greetingMessage';
import { Container } from './GuardDashboard.style';
import { AllMachines } from './components';

type StateType = {
  time: number,
  title: string,
  showToast: boolean,
};
export type StatePropsType = {
  logs: Array<*>,
  alertLogs: any,
  lotNumber: Number,
  userName: String,
  isPending: Boolean,
};
export type DispatchPropsType = {
  fetchAllLogsRequest: Function,
  guardActionRequest: Function,
};
declare type Props = StatePropsType & DispatchPropsType;

class Guard extends Component<Props & DispatchPropsType, StateType> {
  interval: IntervalID;

  constructor(props) {
    super(props);
    this.state = {
      time: Date.now(),
      showToast: false,
      title: 'Guard Dashboard',
    };
  }

  componentDidMount() {
    const { lotNumber } = this.props;
    if (lotNumber !== undefined) {
      this.fetchData();
    }
    this.interval = setInterval(() => this.setState({}, this.fetchData), 20000);
  }

  componentDidUpdate(prevProps) {
    const { lotNumber } = this.props;
    if (prevProps.lotNumber !== lotNumber) {
      this.fetchData();
    }
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  fetchData = () => {
    const { time } = this.state;
    if ((Date.now() - time) / (5 * 60 * 1000) > 1) {
      window.location.reload(false);
    }
    const { fetchAllLogsRequest, lotNumber } = this.props;
    this.setState({ showToast: true });
    if (lotNumber) fetchAllLogsRequest('guard-logs', lotNumber);
  };

  showToast = (logs) => {
    const alertOptions = {
      position: 'bottom-right',
      autoClose: 1000,
      hideProgressBar: true,
      closeOnClick: true,
      pauseOnHover: false,
    };
    // eslint-disable-next-line array-callback-return
    logs.disrupt.map((log) => {
      toast.warn(`${log.machine.name} is disrupted`, alertOptions);
    });
    // eslint-disable-next-line array-callback-return
    logs.outage.map((log) => {
      toast.error(`${log.machine.name} is not reachable`, alertOptions);
    });
    this.setState({ showToast: false });
  };

  render() {
    const { logs, alertLogs, guardActionRequest, userName } = this.props;
    const { showToast, title } = this.state;
    return (
      <Container>
        <Box sx={{ flexGrow: 1 }}>
          <Grid container>
            <Grid md={12} paddingLeft={1} paddingTop={1}>
              <Typography variant="subtitle1" color="text.primary" gutterBottom>
                {getGreeting()} <b>{userName}</b>, Welcome to TACS {title}
              </Typography>
            </Grid>
          </Grid>
        </Box>

        <Box sx={{ flexGrow: 1 }}>
          <Grid container spacing={1}>
            <Grid md={12} item spacing={1}>
              <Grid spacing={1} md={12}>
                <AllMachines data={logs} guardActionRequest={guardActionRequest} />
              </Grid>
            </Grid>
          </Grid>
        </Box>
        {alertLogs && showToast && this.showToast(alertLogs)}
      </Container>
    );
  }
}

export default withRouter(Guard);
